import { COLORS } from '@/common/constants';
import { FC } from 'react';
import { LoadNavbarItem } from './LoadNavbarItem';

export const NavbarMeasure: FC = () => {
  return (
    <div className="flex items-center justify-center border-b bg-white py-[7px]">
      {COLORS?.map((tab, index) => <LoadNavbarItem tab={tab} key={index} />)}
    </div>
  );
};
